import React from 'react';

const C = {
  bg:'#08090f', card:'#0d1117', inp:'#0f1420',
  border:'#1f2937', borderS:'#1a2035',
  primary:'#e5e7eb', secondary:'#6b7280', muted:'#374151',
  profit:'#16C784', loss:'#ef4444', accent:'#6366f1',
};

function SDiv({ label }) {
  return (
    <div style={{ display:'flex', alignItems:'center', gap:8, margin:'4px 0' }}>
      <div style={{ flex:1, height:1, background:C.borderS }}/>
      <span style={{ color:C.muted, fontSize:9, fontWeight:800, letterSpacing:2, textTransform:'uppercase' }}>{label}</span>
      <div style={{ flex:1, height:1, background:C.borderS }}/>
    </div>
  );
}

function SCard({ children, accent, style={} }) {
  return (
    <div style={{
      borderRadius:12, padding:'10px 12px', boxSizing:'border-box',
      background: accent ? `linear-gradient(135deg,${accent}12 0%,${C.card} 100%)` : C.card,
      border:`1px solid ${accent ? `${accent}28` : C.border}`, ...style,
    }}>
      {children}
    </div>
  );
}

function SHead({ emoji, title, color }) {
  return (
    <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:8 }}>
      <div style={{ width:20, height:20, borderRadius:6, background:`${color||C.accent}22`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, fontSize:11 }}>
        {emoji}
      </div>
      <span style={{ color:C.primary, fontSize:11, fontWeight:800, textTransform:'uppercase', letterSpacing:1 }}>{title}</span>
    </div>
  );
}

function MC({ label, value, color }) {
  return (
    <div style={{ padding:'5px 8px', borderRadius:8, background:color?`${color}10`:C.inp, border:`1px solid ${color?`${color}22`:C.border}` }}>
      <div style={{ color:C.secondary, fontSize:8, fontWeight:600, marginBottom:1 }}>{label}</div>
      <div style={{ color:color||C.primary, fontSize:11, fontWeight:800, lineHeight:1.2 }}>{value??'—'}</div>
    </div>
  );
}

function Pill({ label, color }) {
  return (
    <span style={{ display:'inline-block', background:`${color}18`, color, border:`1px solid ${color}28`, borderRadius:20, padding:'2px 8px', fontSize:9, fontWeight:700, marginRight:3, marginBottom:3 }}>
      {label}
    </span>
  );
}

function RiskCalcShareCard({ snap, cardRef }) {
  if (!snap) return null;

  const {
    capital=0, numFilled=0, numTrades=0,
    totalCapitalUsed=0, totalNetProfit=0, totalNetLoss=0,
    totalActualLoss=0, totalBrokerage=0,
    tier=null, riskProfile=null,
    anyHasSL=false, anyHasTarget=false,
    trades=[],
  } = snap;

  const inr = v => `₹${Math.abs(Math.round(Number(v))).toLocaleString('en-IN')}`;
  const rr  = anyHasSL && anyHasTarget && totalNetLoss>0 ? (totalNetProfit/totalNetLoss).toFixed(1) : null;
  const rrNum = rr ? parseFloat(rr) : 0;
  const rrOk  = rrNum>=2; const rrFair = rrNum>=1.5;
  const rrCol = rr ? (rrOk?C.profit:rrFair?'#f59e0b':C.loss) : C.secondary;
  const rrLabel = rr ? (rrOk?'Good R:R':rrFair?'Acceptable':'Poor R:R') : '—';
  const deployedPct = capital>0 ? ((totalCapitalUsed/capital)*100).toFixed(1) : null;
  const deployedNum = deployedPct ? parseFloat(deployedPct) : 0;
  const deployedCol = deployedNum>80?'#f59e0b':deployedNum>50?C.profit:'#9ca3af';
  const TIER_COLORS = { Elite:'#f59e0b', Advanced:C.accent, Standard:C.profit, Restricted:'#f97316', Minimum:C.loss };
  const tierCol = TIER_COLORS[tier] || C.accent;
  const dateStr = new Date().toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'});

  return (
    <div
      ref={cardRef}
      style={{
        width:1080, height:1350, background:C.bg, overflow:'hidden', position:'relative',
        fontFamily:"'Segoe UI',system-ui,-apple-system,sans-serif",
        display:'flex', flexDirection:'column', padding:28, gap:7, boxSizing:'border-box',
      }}
    >
      {/* Ambient glow */}
      <div style={{ position:'absolute', top:-80, right:-80, width:200, height:200, borderRadius:'50%', background:`radial-gradient(circle,${tierCol}0e 0%,transparent 65%)`, pointerEvents:'none' }}/>

      {/* Header */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:4, flexShrink:0 }}>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <div style={{ width:28, height:28, borderRadius:8, background:'linear-gradient(135deg,#22c55e30,#22c55e10)', border:'1px solid #22c55e35', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <span style={{ color:'#22c55e', fontSize:14, fontWeight:900 }}>T</span>
          </div>
          <span style={{ color:'#fff', fontSize:16, fontWeight:800 }}>TradeReflex</span>
        </div>
        <span style={{ color:C.muted, fontSize:11 }}>{dateStr}</span>
        <span style={{ color:C.muted, fontSize:11 }}>tradereflex.in</span>
      </div>

      {/* Hero */}
      <SCard accent={tierCol}>
        <p style={{ color:C.secondary, fontSize:10, margin:'0 0 3px', textTransform:'uppercase', letterSpacing:'1.5px', fontWeight:700 }}>Position Size Plan</p>
        <p style={{ color:'#fff', fontSize:30, fontWeight:900, margin:'0 0 6px', letterSpacing:'-1px', lineHeight:1 }}>{numFilled} of {numTrades} trades planned</p>
        <div style={{ display:'flex', gap:5, flexWrap:'wrap' }}>
          {tier && <Pill label={`${tier} Tier`} color={tierCol}/>}
          {riskProfile && <Pill label={riskProfile} color="#818cf8"/>}
          {capital>0 && <Pill label={`Capital ${inr(capital)}`} color={C.secondary}/>}
        </div>
      </SCard>

      {/* 2-column: Best/Worst case */}
      {anyHasSL && anyHasTarget && (
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:7 }}>
          <SCard accent={C.profit}>
            <p style={{ color:C.profit, fontSize:10, fontWeight:700, margin:'0 0 3px', textTransform:'uppercase', letterSpacing:'0.8px' }}>Best Case</p>
            <p style={{ color:C.profit, fontSize:26, fontWeight:900, margin:'0 0 2px', letterSpacing:'-0.5px' }}>+{inr(totalNetProfit)}</p>
            <p style={{ color:'#16C78460', fontSize:10, margin:0 }}>all targets hit</p>
          </SCard>
          <SCard accent={C.loss}>
            <p style={{ color:C.loss, fontSize:10, fontWeight:700, margin:'0 0 3px', textTransform:'uppercase', letterSpacing:'0.8px' }}>Worst Case</p>
            <p style={{ color:C.loss, fontSize:26, fontWeight:900, margin:'0 0 2px', letterSpacing:'-0.5px' }}>−{inr(totalNetLoss)}</p>
            <p style={{ color:'#ef444460', fontSize:10, margin:0 }}>all SLs hit</p>
          </SCard>
        </div>
      )}

      {/* Risk metrics */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:7 }}>
        {rr && <MC label={`Plan R:R · ${rrLabel}`} value={`1:${rr}`} color={rrCol}/>}
        {deployedPct && <MC label="Capital Used" value={`${deployedPct}%`} color={deployedCol}/>}
        <MC label="Trades" value={`${numFilled}/${numTrades}`} color={tierCol}/>
      </div>

      {deployedPct && (
        <SCard>
          <div style={{ display:'flex', justifyContent:'space-between', marginBottom:5 }}>
            <span style={{ color:C.secondary, fontSize:10, fontWeight:700 }}>CAPITAL DEPLOYMENT</span>
            <span style={{ color:deployedCol, fontSize:10, fontWeight:800 }}>{deployedPct}% · {inr(totalCapitalUsed)}</span>
          </div>
          <div style={{ height:5, borderRadius:3, background:C.border, overflow:'hidden' }}>
            <div style={{ width:`${Math.min(deployedNum,100)}%`, height:'100%', background:`linear-gradient(90deg,${deployedCol}99,${deployedCol})`, borderRadius:3 }}/>
          </div>
        </SCard>
      )}

      <SDiv label="Trade Details"/>

      {/* Per-trade table */}
      {trades.length>0 && (
        <SCard>
          <SHead emoji="📋" title="Each Trade" color="#f59e0b"/>
          <div style={{ display:'flex', flexDirection:'column', gap:0 }}>
            <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1fr 1fr 1fr 1fr', gap:4, padding:'4px 0', borderBottom:`1px solid ${C.border}` }}>
              {['Symbol','Entry','SL','Target','R:R','Max Loss'].map(h => (
                <span key={h} style={{ color:C.muted, fontSize:9, fontWeight:800, textTransform:'uppercase' }}>{h}</span>
              ))}
            </div>
            {trades.map((t,i) => {
              if (!t) return null;
              const rrN = t.rr?parseFloat(t.rr):0;
              const trRrCol = t.rr?(rrN>=2?C.profit:rrN>=1.5?'#f59e0b':C.loss):C.secondary;
              return (
                <div key={i} style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1fr 1fr 1fr 1fr', gap:4, padding:'6px 0', borderBottom:i<trades.length-1?`1px solid ${C.borderS}`:'none', alignItems:'center', opacity:t._empty?0.45:1 }}>
                  <span style={{ color:C.primary, fontSize:11, fontWeight:800, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{t.label||`Trade ${i+1}`}</span>
                  <span style={{ color:C.primary, fontSize:11, fontWeight:700 }}>{t.entry>0?`₹${t.entry.toFixed(1)}`:'—'}</span>
                  <span style={{ color:t._empty?C.secondary:C.loss, fontSize:11, fontWeight:700 }}>{t.sl>0?`₹${t.sl.toFixed(1)}`:'—'}</span>
                  <span style={{ color:t._empty?C.secondary:C.profit, fontSize:11, fontWeight:700 }}>{t.target>0?`₹${t.target.toFixed(1)}`:'—'}</span>
                  <span style={{ color:trRrCol, fontSize:11, fontWeight:800 }}>{t.rr?`1:${t.rr}`:'—'}</span>
                  <span style={{ color:t._empty?C.secondary:C.loss, fontSize:11, fontWeight:700 }}>{t.actualMaxLoss>0?`−${inr(t.actualMaxLoss)}`:'—'}</span>
                </div>
              );
            })}
          </div>
        </SCard>
      )}

      <SDiv label="Summary"/>

      {/* Summary rows */}
      <SCard>
        <div style={{ display:'flex', flexDirection:'column', gap:0 }}>
          {[
            { label:'Total capital deployed',               value:inr(totalCapitalUsed),       color:'#fff' },
            anyHasSL     && { label:'Max loss (all SLs hit)',    value:`−${inr(totalActualLoss)}`,  color:C.loss },
            anyHasTarget && { label:'Max profit (all targets)',  value:`+${inr(totalNetProfit)}`,   color:C.profit },
            { label:`Brokerage (${numFilled} trades)`,       value:`~${inr(totalBrokerage)}`,    color:'#f59e0b' },
            rr && { label:`Plan R:R · ${rrLabel}`,           value:`1:${rr}`,                    color:rrCol },
          ].filter(Boolean).map((row,i,arr) => (
            <div key={row.label} style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', borderBottom:i<arr.length-1?`1px solid ${C.borderS}`:'none' }}>
              <span style={{ color:C.secondary, fontSize:11, fontWeight:600 }}>{row.label}</span>
              <span style={{ color:row.color, fontSize:11, fontWeight:800 }}>{row.value}</span>
            </div>
          ))}
        </div>
      </SCard>

      {/* Footer */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', paddingTop:8, borderTop:`1px solid ${C.borderS}`, flexShrink:0, marginTop:'auto' }}>
        <span style={{ color:C.muted, fontSize:10 }}>Know your edge · TradeReflex</span>
        <span style={{ color:C.secondary, fontSize:10, fontWeight:700 }}>tradereflex.in</span>
      </div>
    </div>
  );
}

export default RiskCalcShareCard;
